"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientReducer = exports.setSelectedClientIntegration = exports.setSelectedClientUser = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("../../../screens/console/pages/users/constants");
var initialState = {
    selectedClientUser: constants_1.initialUserValues,
    selectedClientIntegration: {},
};
// only the two editor drafts live here: the client record and its subscription come from clientApi
var slice = (0, toolkit_1.createSlice)({
    name: "client",
    initialState: initialState,
    reducers: {
        setSelectedClientUser: function (state, action) {
            state.selectedClientUser = action.payload;
        },
        setSelectedClientIntegration: function (state, action) {
            state.selectedClientIntegration = action.payload;
        },
    },
});
var _a = slice.actions, setSelectedClientUser = _a.setSelectedClientUser, setSelectedClientIntegration = _a.setSelectedClientIntegration;
exports.setSelectedClientUser = setSelectedClientUser;
exports.setSelectedClientIntegration = setSelectedClientIntegration;
var clientReducer = slice.reducer;
exports.clientReducer = clientReducer;
